var exports = {
  "i": "x936d19a0--2b086f--wrapper",
};

module.exports = exports;
